export function getOdigeoSessionValue(key, defaultValue) {
  try {
    return window.Odigeo.SessionScope[key];
  } catch (e) {
    return defaultValue;
  }
}